const menu = document.querySelector('.header-main__menu');
const select = document.querySelector('#order');

if (menu && select) {
  menu.addEventListener('mouseenter', function () {
    select.blur();
  });
}
